export const moduleNames = {
  ranking: "ranking",
  salesAverage: "salesAverage",
  salesActive: "salesActive",
  salesExpired: "salesExpired",
  inventoryTarget: "inventoryTarget",
  branchCategory: "branchCategory",
  packages: " packages",
  customerProfiling: "customerProfiling",
  unredeemedPawns: "unredeemedPawns",
};

export const OperationScope = {
  overall: "Overall",
  specifiedCluster: "SpecificCluster",
  specifiedArea: "SpecificArea",
  specifiedBranch: "SpecificBranch",
};
